export const PRODUCTS = 'PRODUCTS';
export const CHARGING = 'CHARGING';
export const RECHARGING = 'RECHARGING';
export const VOUCHERS = 'VOUCHERS';
export const BARRING = 'BARRING';

export default {
  PRODUCTS,
  CHARGING,
  RECHARGING,
  VOUCHERS,
  BARRING,
};
